__turbopack_context__.v({
  "className": "be_vietnam_pro_7287a322-module__W3AQ2G__className",
  "variable": "be_vietnam_pro_7287a322-module__W3AQ2G__variable",
});
